<script>
import App from '@/pages/layouts/app.vue'
import {Link} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";
import Datatable from "@wielink-application/shared/js/mixins/datatable";
import Menu from "@/pages/products/_menu.vue";
import TablePlugin from "@wielink/datatables";
import DefaultRenderers from "@wielink/datatables/Renderers/DefaultRenderers";
import ActionsRenderer from "@jntestapparatuur/customer-management/js/ActionsRenderer"
import ConceptRenderer from "@jntestapparatuur/customer-management/js/ConceptRenderer"

export default {
	mixins: [Datatable],
	components: {Menu, Card, App, Link},
	props: ['productId'],
	methods: {
		initialiseDatatable() {
			new TablePlugin({
				scope: this.$refs.table.$refs.table,
				renderers: {
          ...DefaultRenderers,
          'customActionsRenderer': ActionsRenderer,
          'concept': ConceptRenderer}
			});
		}
	}
}
</script>

<template>
	<App title="Keuringsrapporten">
		<Menu :product-id="productId"/>

		<Card>
			<Table id="product_inspection_reports" ref="table" :config="tableConfig"/>
		</Card>
	</App>
</template>